var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchCategoryMediaServices32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture-Category/32/Media-Services_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8511B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-Category/32/Media-Services_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)",
    x: 4,
    y: 4,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    id: "#879196-Border-Copy-16",
    stroke: "#879196",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 46,
    height: 46
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Category/32/Media-Services_32",
    transform: "translate(8.000000, 8.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.592,16.094 L9.327,20.463 C9.238,20.523 9.153,20.496 9.112,20.474 C9.07,20.451 9,20.398 9,20.288 L9,11.575 C9,11.465 9.071,11.411 9.112,11.389 C9.133,11.378 9.165,11.365 9.206,11.365 C9.245,11.365 9.293,11.377 9.347,11.412 L16.572,15.756 C16.654,15.81 16.666,15.889 16.666,15.931 C16.666,15.973 16.654,16.052 16.592,16.094 L16.592,16.094 Z M17.108,14.911 L9.882,10.568 C9.512,10.32 9.035,10.296 8.64,10.507 C8.245,10.719 8,11.128 8,11.575 L8,20.288 C8,20.736 8.245,21.145 8.64,21.356 C8.821,21.453 9.021,21.5 9.216,21.5 C9.446,21.5 9.672,21.435 9.863,21.308 L17.127,16.939 C17.465,16.714 17.666,16.337 17.666,15.931 C17.666,15.526 17.465,15.149 17.108,14.911 L17.108,14.911 Z M29,21.789 C29,21.906 28.905,22 28.789,22 L27,22 L27,10 L28.789,10 C28.905,10 29,10.094 29,10.21 L29,21.789 Z M23.768,18 L21,18 L21,25.079 C21,25.587 20.587,26 20.079,26 L3.921,26 C3.413,26 3,25.587 3,25.079 L3,6.921 C3,6.413 3.413,6 3.921,6 L20.079,6 C20.587,6 21,6.413 21,6.921 L21,14 L23.768,14 L26,10.652 L26,21.348 L23.768,18 Z M28.789,9 L27,9 L26,9 L25.9,9 L23.233,13 L22,13 L22,6.921 C22,5.862 21.139,5 20.079,5 L3.921,5 C2.862,5 2,5.862 2,6.921 L2,25.079 C2,26.138 2.862,27 3.921,27 L20.079,27 C21.139,27 22,26.138 22,25.079 L22,19 L23.233,19 L25.9,23 L28.789,23 C29.457,23 30,22.457 30,21.789 L30,10.21 C30,9.543 29.457,9 28.789,9 L28.789,9 Z",
    id: "Media-Services_Category-Icon_32_Squid"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchCategoryMediaServices32);
export default __webpack_public_path__ + "static/media/Arch-Category_Media-Services_32.1867f6827c2dbf6d37eca450c0c260c9.svg";
export { ForwardRef as ReactComponent };